export const YEARLYSchedule = {
  2022: {
    pennant: { start: "2022-03-25", end: "2022-10-03" },
    interLeague: { start: "2022-05-24", end: "2022-06-12" },
    Apr: { start: "2022-03-25", end: "2022-04-30" },
    May: { start: "2022-05-01", end: "2022-05-31" },
    Jun: { start: "2022-06-01", end: "2022-06-30" },
    Jul: { start: "2022-07-01", end: "2022-07-31" },
    Aug: { start: "2022-08-01", end: "2022-08-31" },
    Sep: { start: "2022-09-01", end: "2022-10-03" },
  },
  2023: {
    pennant: { start: "2023-03-30", end: "2023-10-10" },
    interLeague: { start: "2023-05-30", end: "2023-06-21" },
    Apr: { start: "2023-03-25", end: "2023-04-30" },
    May: { start: "2023-05-01", end: "2023-05-31" },
    Jun: { start: "2023-06-01", end: "2023-06-30" },
    Jul: { start: "2023-07-01", end: "2023-07-31" },
    Aug: { start: "2023-08-01", end: "2023-08-31" },
    Sep: { start: "2023-09-01", end: "2023-10-10" },
  },
  2024: {
    pennant: { start: "2024-03-29", end: "2024-10-09" },
    interLeague: { start: "2024-05-28", end: "2024-06-16" },
    Apr: { start: "2024-03-29", end: "2024-04-30" },
    May: { start: "2024-05-01", end: "2024-05-31" },
    Jun: { start: "2024-06-01", end: "2024-06-30" },
    Jul: { start: "2024-07-01", end: "2024-07-31" },
    Aug: { start: "2024-08-01", end: "2024-08-31" },
    Sep: { start: "2024-09-01", end: "2024-10-09" },
  },
  2025: {
    pennant: { start: "2025-03-28", end: "2025-10-05" },
    interLeague: { start: "2025-06-03", end: "2025-06-24" },
    Apr: { start: "2025-03-28", end: "2025-04-30" },
    May: { start: "2025-05-01", end: "2025-05-31" },
    Jun: { start: "2025-06-01", end: "2025-06-30" },
    Jul: { start: "2025-07-01", end: "2025-07-31" },
    Aug: { start: "2025-08-01", end: "2025-08-31" },
    Sep: { start: "2025-09-01", end: "2025-10-05" },
  },
} as const;
